import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-column-selector',
	templateUrl: './column-selector.component.html',
	styleUrls: ['./column-selector.component.scss']
})
export class ColumnSelectorComponent implements OnInit {

	@Input() columns: any[];

	constructor() {

	}

	ngOnInit(): void {
	}

	toogleColumn(column: any){
		if(column.showed){
			column.showed = false;
		} else {
			column.showed = true;
		}
	}

}

